module.exports = __webpack_public_path__ + "img/avatarFemale.4e2fd140.svg";